import styles from "./ContactSection.module.scss";
import MainButton from "../../../shared/button/MainButton";
import email from "../../../../assets/images/pages/home/contact/Email Icon.svg";
import phone from "../../../../assets/images/pages/home/contact/Phone Icon.svg";
import insta from "../../../../assets/images/pages/home/contact/social-media/Instagram Icon.svg";
import fbook from "../../../../assets/images/pages/home/contact/social-media/Facebook Icon.svg";
import form_user from "../../../../assets/images/pages/home/contact/form/User.svg";
import form_email from "../../../../assets/images/pages/home/contact/form/Email.svg";
import form_note from "../../../../assets/images/pages/home/contact/form/Note.svg";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { AiOutlineYoutube } from "react-icons/ai";
import { ContactServices } from "../../../../services/contact.service";
import { useState } from "react";
import { toast } from "react-toastify";
const ContactSection = () => {
  const YoutubeIcon = AiOutlineYoutube as unknown as React.FC;

  const { data } = useSelector((state: RootState) => state.translationData);
  const [form, setForm] = useState({
    email: "",
    fullName: "",
    text: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await ContactServices.SendMail(form);
      toast.success(data?.message_sent);
      setForm({ fullName: "", email: "", text: "" });
    } catch (err: any) {
      toast.error(err || data?.error_occurred);
    } finally {
      setLoading(false);
    }
  };
  const isDisabled = form.email && form.fullName && form.text;

  return (
    <div id={styles.contact_section}>
      <div className="container">
        <div className={styles.contact_section}>
          <div className={styles.contact_info}>
            <h1 className={styles.title}>{data?.contact}</h1>
            <p className={styles.description}>{data?.contact_text}</p>
            <div className={styles.infos}>
              <a
                target="_blank"
                href={"mailto:" + data?.contact_email}
                className={styles.info_button}
              >
                <img src={email} alt="email" />
                <p>{data?.contact_email}</p>
              </a>
              <a
                href={"tel:" + (data?.contact_phone || "").replace(/[^\d+]/g, "")}
                className={styles.info_button}
              >
                <img src={phone} alt="phone" />
                <p>{data?.contact_phone}</p>
              </a>
              {data?.contact_mobile && (
                <a
                  href={"tel:" + data.contact_mobile.replace(/[^\d+]/g, "")}
                  className={styles.info_button}
                >
                  <img src={phone} alt="phone" />
                  <p>{data.contact_mobile}</p>
                </a>
              )}
            </div>
            <div className={styles.infos}>
              <p
                className={styles.content}
                dangerouslySetInnerHTML={{
                  __html: data?.working_hours_html || "",
                }}
              />
            </div>
            <div className={styles.social_media}>
              <h1 className={styles.media_title}>{data?.follow_us}</h1>
              <div className={styles.social_media_icons}>
                <a
                  href={data?.contact_youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className={styles.icon}>
                    <YoutubeIcon />
                  </div>
                </a>

                <a
                  href={data?.contact_instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className={styles.icon}>
                    <img src={insta} alt="insta" />
                  </div>
                </a>

                <a
                  href={data?.contact_facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className={styles.icon}>
                    <img src={fbook} alt="fbook" />
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className={styles.contact}>
            <form onSubmit={handleSubmit} className={styles.form}>
              <div className={styles.input}>
                <img src={form_user} alt="user" />
                <input
                  type="text"
                  name="fullName"
                  value={form.fullName}
                  onChange={handleChange}
                  placeholder={data?.name}
                  className={styles.nameInput}
                />
              </div>
              <div className={styles.input}>
                <img src={form_email} alt="email" />
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder={data?.email}
                  className={styles.nameInput}
                />
              </div>
              <div className={styles.input}>
                <img src={form_note} alt="note" />
                <textarea
                  name="text"
                  value={form.text}
                  onChange={handleChange}
                  placeholder={data?.message}
                />
              </div>
              <MainButton
                className={styles.contact_btn}
                text={data?.send}
                disabled={!isDisabled}
                isLoading={loading}
                onClick={handleSubmit}
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
